//引入Vue
import Vue from 'vue'
//引入App
import App from './App.vue'
//引入VueRouter
import VueRouter from 'vue-router'
//引入路由器
import router from './router'

// 引入自定义插件并使用,插件中包含mixin,注册全局组件...
import plugins from './plugins'
Vue.use(plugins)

// 引入阿里字体图标
import '@alifont/iconfont.css';
// 引入bootstrap
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap/dist/js/bootstrap.min'

// 引入动画
import 'animate.css'

// 引入ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 引入全局样式文件，重置浏览器样式 最后引入权重高
import '@css/reset.css'
//引入store
import store from './store'

//关闭Vue的生产提示
Vue.config.productionTip = false

//应用理由插件
Vue.use(VueRouter)

// 在 Vue 实例创建之前检测登录信息,获取用户信息
store.dispatch('home/getUserInofo').then(() => {
	// 创建 Vue 实例+
	new Vue({
		el: '#app',
		render: h => h(App),
		router: router,
		store,
		beforeCreate() {
			// 全局事件总线
			Vue.prototype.$bus = this
		},
	});
}).catch(error => {
	console.error('Failed to fetch user info:', error);
});

// //创建vm
// new Vue({
// 	el: '#app',
// 	render: h => h(App),
// 	router: router,
// 	store,
// 	beforeCreate() {
// 		// 全局事件总线
// 		Vue.prototype.$bus = this
// 	},
// })
